import { CheckIcon } from "@heroicons/react/24/solid"
import { cn } from "#app/utils/misc.tsx"

type JourneyStep = "Start" | "Touchpoint Selection" | "Confirm" | "Results"

export const JourneyProgressBar = ({
	currentStep,
}: {
	currentStep: JourneyStep
}) => {
	let progressPercentage = 0
	switch (currentStep) {
		case "Start":
			progressPercentage = 16.66665
			break
		case "Touchpoint Selection":
			progressPercentage = 33.3333
			break
		case "Confirm":
			progressPercentage = 66.6666
			break
		case "Results":
			progressPercentage = 100
			break
		default:
			return 0
	}

	return (
		<div>
			<h4 className="sr-only">
				Journey Progress - Current Step: {currentStep}
			</h4>
			<div aria-hidden="true" className="mt-6">
				<div className="relative rounded-full bg-gray-200">
					<div
						style={{ width: `${progressPercentage}%` }}
						className="h-1 rounded-full bg-colors-cobalt"
					>
						<Checkmark
							label="Start"
							state={currentStep === "Start" ? "in progress" : "complete"}
							classNames="-left-3"
						/>
						<Checkmark
							label="Touchpoint Selection"
							state={
								currentStep === "Touchpoint Selection"
									? "in progress"
									: currentStep === "Start"
										? "not started"
										: "complete"
							}
							classNames="left-[33.3333%]"
						/>
						<Checkmark
							label="Confirm"
							state={
								currentStep === "Confirm"
									? "in progress"
									: currentStep === "Touchpoint Selection" ||
										  currentStep === "Start"
										? "not started"
										: "complete"
							}
							classNames="left-[66.6666%]"
						/>
						<Checkmark
							label="Done"
							state={
								currentStep === "Results"
									? "complete"
									: currentStep === "Confirm" ||
										  currentStep === "Touchpoint Selection" ||
										  currentStep === "Start"
										? "not started"
										: "complete"
							}
							classNames="left-[98%]"
						/>
					</div>
				</div>
			</div>
		</div>
	)
}

type CheckmarkState = "complete" | "in progress" | "not started"
const Checkmark = ({
	state,
	label,
	classNames,
}: {
	state: CheckmarkState
	label: string
	classNames?: string
}) => (
	<div
		className={cn(
			classNames,
			state === "complete" && "bg-colors-cobalt",
			state === "in progress" && "border border-colors-cobalt bg-white",
			state === "not started" && "border border-gray-300 bg-white",
			"absolute -top-[10px] flex h-6 w-6 items-center justify-center rounded-full",
		)}
	>
		{state === "complete" && (
			<CheckIcon className="absolute inset-0 top-[5px] mx-auto h-[15px] w-[15px] text-white" />
		)}
		{state === "in progress" && (
			<div className="absolute inset-0 top-[7px] mx-auto flex h-2 w-2 rounded-full bg-colors-cobalt text-transparent" />
		)}
		{state === "not started" && (
			<div className="absolute inset-0 top-[7px] mx-auto flex h-2 w-2 rounded-full bg-gray-300 text-transparent" />
		)}
		<span className="translate-y-6 text-nowrap text-center text-xs text-gray-600 md:text-sm lg:text-base">
			{label}
		</span>
	</div>
)
